// --- Storage with 24h expiry ---
function setWithExpiry(key, value, ttlHours = 24) {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttlHours * 60 * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key); // expired
    return null;
  }
  return item.value;
}

// --- State with 24h expiry ---
const state = {
  model: getWithExpiry('bodno:model') || '',
  modelHref: getWithExpiry('bodno:modelHref') || '',
  modelProductId: getWithExpiry('bodno:modelProductId') || '',
  ribbonImage: getWithExpiry('bodno:ribbonImage') || '',
  ribbonUrl: getWithExpiry('bodno:ribbonUrl') || '',
  ribbonTitle: getWithExpiry('bodno:ribbonTitle') || '',
  productImage: getWithExpiry('bodno:productImage') || '',
  boxItems: null,
  registered: getWithExpiry('bodno:registered') === 'true',
  currentStep: Number(getWithExpiry('bodno:step') || 0),
};

const stepLabels = [
  'Registration',
  'Driver Installation',
  'Bodno Software Installation',
  'Unboxing the Printer',
  'Connect the Printer',
  'Install Ribbons and Cards',
  'Test Your Printer',
  'Start Designing Cards',
  'Essential Maintenance Tips',
  'Setup Completed 🎉',
];

const totalSteps = stepLabels.length;

// Oct 22 2026: renamed from $ / $$. A global "const $" here replaced jQuery's $ for the whole page and crashed script.js + cart-sidebar.js. Never name a global helper $.
const __bnq = (q, ctx = document) => ctx.querySelector(q);
const __bnqa = (q, ctx = document) => Array.from(ctx.querySelectorAll(q));

const welcomeView = __bnq('#welcomeView');
const stepsView = __bnq('#stepsView');
const stepperEl = __bnq('#stepper');
const stepperWrap = __bnq('#stepperWrap');

// --- Stepper builder ---
function buildStepper() {
  stepperEl.innerHTML = '';
  for (let i = 1; i <= totalSteps; i++) {
    const li = document.createElement('div');
    li.className = 'step';
    li.dataset.step = i;
    li.innerHTML = `<button aria-label="Go to step ${i}"><span class="dot"></span><span class="label"><p class="f--1_125rem lh--loose f--grey-dark f--bold-500 mf--1rem">Step ${i}:</p> <p class="f--1rem lh--loose f--grey-dark f--regular  mf--0_875rem">${stepLabels[i - 1]}</p></span></button>`;
    li.addEventListener('click', () => goToStep(i));
    stepperEl.appendChild(li);
  }
}

// --- View logic ---
function setViewVisibility() {
  const urlParams = new URLSearchParams(window.location.search);
  const stepParam = urlParams.get("step");

  if (stepParam === "welcome" && !state.registered && !state.currentStep) {
    // ✅ Show welcome if explicitly in URL (first visit)
    welcomeView.classList.add("visible");
    welcomeView.classList.remove("hidden");
    stepsView.classList.add("hidden");
    stepsView.classList.remove("visible");
  } else {
    // ✅ Otherwise go straight to steps
    welcomeView.classList.add("hidden");
    welcomeView.classList.remove("visible");
    stepsView.classList.remove("hidden");
    stepsView.classList.add("visible");
    stepperWrap.classList.add("visible");

    // If nothing stored, start at step 1
    if (!state.currentStep || state.currentStep === 0) {
      state.currentStep = 1;
      setWithExpiry("bodno:step", "1");
    }
  }
}

function renderStepper() {
  __bnqa('.step', stepperEl).forEach((el) => {
    const i = Number(el.dataset.step);
    el.classList.remove('active', 'complete', 'locked');

    if (i === state.currentStep) {
      el.classList.add('active');
    } else if (i < state.currentStep) {
      el.classList.add('complete');
    }

    // 🔑 Normally lock >1 if not registered
    // but if a model is stored, unlock all
    const hasModel = !!getWithExpiry("bodno:model");
    if (!state.registered && !hasModel && i > 1) {
      el.classList.add('locked');
    }
  });

  if (state.currentStep === 1) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

function showStep(step) {
  __bnqa('.regcard[id^="step-"]').forEach((s) => s.classList.add('hidden'));
  const section = __bnq(`#step-${step}`);
  if (section) {
    section.classList.remove('hidden');
  }
}

// Oct 22 2026: tapping a locked step used to do nothing (Clarity dead clicks). Now it says why.
function showLockedHint() {
  let hint = document.getElementById('bnq-locked-hint');
  if (!hint) {
    hint = document.createElement('div');
    hint.id = 'bnq-locked-hint';
    hint.setAttribute('role', 'status');
    hint.style.cssText = 'margin:0 0 16px;padding:12px 16px;border-radius:10px;background:#FFF6E0;border:1px solid #F0D68A;color:#5C4300;font-size:15px;line-height:1.45;';
    hint.textContent = 'Register your printer below to unlock the setup steps. It takes about a minute.';
    const card = document.getElementById('step-1');
    if (card) card.prepend(hint);
    else if (stepperWrap) stepperWrap.appendChild(hint);
  }
  hint.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function goToStep(step) {
  if (!state.registered && step > 1) {
    const lockedEl = stepperEl && stepperEl.querySelector(`.step[data-step="${step}"]`);
    if (lockedEl && lockedEl.classList.contains('locked')) showLockedHint();
    return;
  }

  state.currentStep = step;
  setWithExpiry('bodno:step', String(step));

  renderStepper();
  showStep(step);
  window.scrollTo({ top: 0, behavior: 'smooth' });

     // ✅ Mobile view: center the clicked step horizontally
  if (window.innerWidth <= 767) {
    const stepEl = stepperEl.querySelector(`.step[data-step="${step}"]`);
    if (stepEl) {
      const container = stepperEl;

      // Calculate center offset
      const containerRect = container.getBoundingClientRect();
      const stepRect = stepEl.getBoundingClientRect();

      const offset = 
        stepRect.left - containerRect.left - containerRect.width / 2 + stepRect.width / 2;

      container.scrollBy({ left: offset, behavior: "smooth" });
    }
  }
}

// --- Registration completion ---
function completeRegistration() {
  state.registered = true;
  setWithExpiry('bodno:registered', 'true');
}

// --- Registration submit ---
document.addEventListener("click", function (e) {
  if (e.target && e.target.id === "submit-register-your-printer") {
    e.preventDefault();

    const getVal = (selector) => document.querySelector(selector)?.value.trim() || "";

    const fields = {
      first_name: getVal('input[name="first_name"]'),
      last_name: getVal('input[name="last_name"]'),
      company_name: getVal('input[name="company_name"]'),
      email: getVal('input[name="email"]'),
      phone_number: getVal('input[name="phone_number"]'),
      serial_number: getVal('input[name="serial_number"]'),
      address: getVal('input[name="address"]'),
      city: getVal('input[name="city"]'),
      state: getVal('select[name="state"]'),
      zipcode: getVal('input[name="zipcode"]'),
      order_from: document.querySelector('select[name=order_from]')?.value || "",
      order_number: getVal('input[name="order_number"]'),
    };

    const errorBox = document.querySelector(".error-msg");

    const amazonInput = document.querySelector('input[name="amazon_order"]');
    const bodnoInput = document.querySelector('input[name="bodno_order"]');
    const otherInput = document.querySelector('input[name="other_order"]');
    
    document.querySelectorAll(".field-error").forEach(el => el.remove());
    document.querySelectorAll("input, select").forEach(el => el.classList.remove("input-error"));
    if (errorBox) errorBox.innerHTML = "";

    const showError = (selector, msg) => {
      const input = document.querySelector(selector);
      if (!input) return;
      input.classList.add("input-error");

      if (!input.nextElementSibling || !input.nextElementSibling.classList.contains("field-error")) {
        const errorMsg = document.createElement("div");
        errorMsg.className = "field-error";
        errorMsg.textContent = msg;
        input.insertAdjacentElement("afterend", errorMsg);
      }
    };

    let valid = true;
    if (!fields.first_name) { showError('input[name="first_name"]', "First name required"); valid = false; }
    if (!fields.last_name) { showError('input[name="last_name"]', "Last name required"); valid = false; }
    if (!fields.phone_number) { showError('input[name="phone_number"]', "Phone number required"); valid = false; }
    else if (!validateEmail(fields.email)) { showError('input[name="email"]', "Invalid email"); valid = false; }
    if (!fields.serial_number) { showError('input[name="serial_number"]', "Serial number required"); valid = false; }
    if (!fields.address) { showError('input[name="address"]', "Address required"); valid = false; }
    if (!fields.city) { showError('input[name="city"]', "City required"); valid = false; }
    if (!fields.state) { showError('select[name="state"]', "State required"); valid = false; }
    if (!fields.zipcode) { showError('input[name="zipcode"]', "Zipcode required"); valid = false; }
    if (!fields.order_number) { showError('input[name="order_number"]', "Order number required"); valid = false; }

    if (!valid) return;

    if (!valid) return;

    if (amazonInput) amazonInput.value = "";
    if (bodnoInput) bodnoInput.value = "";
    if (otherInput) otherInput.value = "";

    if (fields.order_from === "amazon" && amazonInput) {
      amazonInput.value = fields.order_number;
    } else if (fields.order_from === "bodno" && bodnoInput) {
      bodnoInput.value = fields.order_number;
    } else if (otherInput) {
      otherInput.value = fields.order_number;
    }

    const amazon_order = amazonInput?.value || "";
    const bodno_order = bodnoInput?.value || "";
    const other_order = otherInput?.value || "";

    const overlay = document.getElementById("ajax-loader-overlay");
    if (overlay) overlay.style.display = "flex";
    fetch("https://api.bodno.com/registered-printer/post", {
      method: "POST",
      //headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...fields, amazon_order, bodno_order, other_order }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (overlay) overlay.style.display = "none";
        if (response.status === "200") {
         const modalEl = document.getElementById("printer-registration-modal");
          const modal = new bootstrap.Modal(modalEl);
          modal.show();

          modalEl.addEventListener("shown.bs.modal", () => {
            stepperEl.classList.add("stepper-disabled");
          });
          modalEl.addEventListener("hidden.bs.modal", () => {
            stepperEl.classList.remove("stepper-disabled");
          });

          const activationKey = response.activation_key;
          const productID = response.product_id;

          // save activation key with 24h expiry
          setWithExpiry("bodno:activation_key", activationKey);
          setWithExpiry("bodno:modelProductId", productID);

          document.getElementById("acti-code").textContent = activationKey;
          document.querySelector("#register-your-printer .license-info").innerHTML =
            `<div class="alert alert-success"><strong>Congratulations!</strong> Your Printer Registered Successfully & Your Software Activation Key Is: "<strong>${activationKey}</strong>"</div>`;

          completeRegistration();
          setWithExpiry("order_number", fields.order_number);
          goToStep(2);

          // ✅ Now fetch product details and save them
          loadPrinterProducts(productID);
        } else {
          if (errorBox) {
            errorBox.innerHTML = `<div class="alert alert-danger">${response.message}<br><a href="/pages/amazon#not-found" style="font-weight:700;text-decoration:underline;color:inherit">Bought on Amazon? Here's how to find your order number and fix this</a></div>`;
            errorBox.style.display = "block";
          }
        }
      })
      .catch((err) => {
        if (overlay) overlay.style.display = "none";
        if (errorBox) {
          errorBox.innerHTML =
            `<div class="alert alert-danger">Something went wrong. Please try again.</div>`;
          errorBox.style.display = "block";
        }
        console.error(err);
      });
  }
});

// --- Model data rendered by the theme (see section-no-236.liquid) ---
function getThemeModel(productID) {
  if (!productID) return null;

  const models = window.BODNO_PRINTER_MODELS || {};
  // Accept a bare id (8517267718398) or a full gid://shopify/Product/8517267718398
  const id = String(productID).trim().split("/").pop();

  return models[id] || null;
}

function applyModelData(model) {
  if (!model || !model.model || !model.modelHref) return false;

  state.model = model.model;
  state.modelHref = model.modelHref;
  state.ribbonImage = model.ribbonImage;
  state.ribbonUrl = model.ribbonUrl;
  state.ribbonTitle = model.ribbonTitle;
  state.productImage = model.productImage || state.productImage;
  state.boxItems = model.boxItems || state.boxItems;

  setWithExpiry("bodno:model", model.model);
  setWithExpiry("bodno:modelHref", model.modelHref);
  setWithExpiry("bodno:ribbonImage", model.ribbonImage);
  setWithExpiry("bodno:ribbonUrl", model.ribbonUrl);
  setWithExpiry("bodno:ribbonTitle", model.ribbonTitle);
  if (model.productImage) setWithExpiry("bodno:productImage", model.productImage);

  return true;
}

function applyModelToUI() {
  if (state.model && state.modelHref) {
    const slug = state.modelHref.toLowerCase()
                   .replace('/pages/', '')      // remove "/pages/"
                   .replace('-support', '')     // remove "-support"
                   .replace(/\s+/g, '-');       // replace spaces with hyphens

    document.getElementById("step-5-download-drive-win")?.setAttribute("href", `/${slug}-driver-win`);
    document.getElementById("step-5-download-drive-mac")?.setAttribute("href", `/${slug}-driver-mac`);

    document.getElementById("step-6-download-software-win")?.setAttribute("href", `/Bodno-software-win`);
    document.getElementById("step-6-download-software-mac")?.setAttribute("href", `/Bodno-software-mac.dmg`);

    document.getElementById("step-9-printer-guide")?.setAttribute("href", `/${slug}-manual`);
  }

  if (state.ribbonImage && state.ribbonUrl) {
    const ribbonLink = document.getElementById("step-9-ribbon-url");
    if (ribbonLink) {
      ribbonLink.setAttribute("href", state.ribbonUrl);
      ribbonLink.textContent = state.ribbonTitle || state.ribbonUrl;
    }
    document.getElementById("step-9-ribbon-url-btn")?.setAttribute("href", state.ribbonUrl);

    const ribbonImg = document.getElementById("step-9-ribbon-image");
    if (ribbonImg) {
      ribbonImg.setAttribute("src", state.ribbonImage);
      ribbonImg.setAttribute("alt", state.ribbonTitle || "Ribbon");
    }
  }

  if (state.productImage) {
    const mainPrinterImg = document.getElementById("main-printer-image-unboxing");
    if (mainPrinterImg) mainPrinterImg.src = state.productImage;
  }

  renderBoxItems();

  if (state.modelHref) {
    loadModelSupport(state.modelHref);
  }
}

// --- "What's in the box" list on the unboxing step ---
function renderBoxItems() {
  const items = state.boxItems;
  if (!Array.isArray(items) || !items.length) return;

  const ul = document.querySelector("#step-4 .description-box ul");
  if (!ul) return;

  ul.innerHTML = "";

  items.forEach((p) => {
    const li = document.createElement("li");
    li.className = "g-box";
    li.innerHTML = `
      <div class="g-box-inner">
        <div class="box-images">
          <img loading="lazy" src="${p.image}" alt="${p.title}">
        </div>
        <p class="__current_title f--0_875rem lh--loose f--black f--bold-500 mt-2">
          ${p.title}
        </p>
      </div>`;
    ul.append(li);
  });
}

// --- Let the customer pick their printer when we can't match their product ---
function showModelPicker() {
  const models = window.BODNO_PRINTER_MODELS || {};
  const ids = Object.keys(models);
  if (!ids.length || document.getElementById("model-picker")) return;

  const anchor = document.getElementById("step-5-download-drive-win")?.closest(".col-12");
  if (!anchor) return;

  const wrap = document.createElement("div");
  wrap.id = "model-picker";
  wrap.className = "g-box-3 mb-3";
  wrap.innerHTML = `
    <div class="g-box-inner-3">
      <p class="f--1_125rem lh--loose f--red f--bold-600 mf--1rem mb-2">Select your printer model</p>
      <p class="f--1rem lh--loose f--black mf--0_875rem mb-3">
        Pick your model and we'll take you to the right driver.
      </p>
      <ul class="list-unstyled support-box-list" style="display: block;"></ul>
    </div>`;

  const list = wrap.querySelector("ul");

  ids
    .sort((a, b) => models[a].model.localeCompare(models[b].model))
    .forEach((id) => {
      const m = models[id];
      const li = document.createElement("li");
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "f--1_25rem lh-1_6875rem f--black f--regular mf--1_125rem lh-1_5rem model";
      btn.textContent = m.model;
      btn.addEventListener("click", () => {
        applyModelData(m);
        setWithExpiry("bodno:modelProductId", String(m.modelProductId));
        applyModelToUI();
        wrap.remove();
      });
      li.appendChild(btn);
      list.appendChild(li);
    });

  anchor.prepend(wrap);
}

// --- Resolve the printer after registration, from the theme's own model data ---
function loadPrinterProducts(productID) {
  const model = getThemeModel(productID);

  if (applyModelData(model)) {
    applyModelToUI();
    return true;
  }

  // Product isn't in the theme's model list — let the customer pick their printer
  // instead of leaving the download buttons dead.
  showModelPicker();
  return false;
}


// Load Model Support Page
let loadedSupportHref = null;
function loadModelSupport(href) {
  if (!href || href === loadedSupportHref) return;
  loadedSupportHref = href;
  fetch(href)
    .then(res => res.text())
    .then(html => {
      const step10 = document.querySelector("#step-10");
      if (!step10) return;

      const existing = step10.querySelector(".model-support-content");
      if (existing) existing.remove();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const mainContent = doc.querySelector("#MainContent");

      const wrapper = document.createElement("div");
      wrapper.className = "model-support-content";
      wrapper.innerHTML = mainContent ? mainContent.innerHTML : "";
      step10.appendChild(wrapper);

      wrapper.querySelectorAll(".row.s-printer-support-new .col-md-6")
        .forEach(el => {
          el.classList.remove("col-md-6");
          el.classList.add("col-md-4");
        });

      initSliders(wrapper);

      if (window.GF && typeof GF.init === 'function') {
        GF.init();
      } else {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/extensions/1e109406-e2b9-4701-8314-dc57a3fb2206/powerful-form-builder-223/assets/globo.formbuilder.index.js';
        document.body.appendChild(script);
      }
    })
    .catch(err => console.error("Failed to load support page:", err));
}

// ✅ function to (re)initialize Slick sliders
function initSliders(scope) {
  const $scope = jQuery(scope || document);

  // Blog Boxes Slider
  $scope.find(".blog-boxes").each(function () {
    const $slider = jQuery(this);
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      infinite: false,
      responsive: [
        { breakpoint: 1250, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 993, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });

    // 🔥 Force re-calc when visible
    setTimeout(() => {
      $slider.slick("setPosition");
    }, 800);
  });

  // Section 102 Slider
  $scope.find(".sec-no-102-slider").each(function () {
    const $slider = jQuery(this);
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }
    $slider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      responsive: [
        { breakpoint: 1201, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 1081, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });

    // 🔥 Force re-calc when visible
    setTimeout(() => {
      $slider.slick("setPosition");
    }, 800);
  });
}

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function hydrateUI() {

  // Restore activation key if exists
  const storedActivationKey = getWithExpiry("bodno:activation_key");
  if (storedActivationKey) {
    document.getElementById("acti-code").textContent = storedActivationKey;
    document.querySelector("#register-your-printer .license-info").innerHTML =
      `<div class="alert alert-success">
         <strong>Congratulations!</strong> Your Printer Registered Successfully 
         & Your Software Activation Key Is: "<strong>${storedActivationKey}</strong>"
       </div>`;
  }

  const storedOrderNumber = getWithExpiry("order_number");
  const modelProductID = getWithExpiry("bodno:modelProductId");

  // Apply whatever model is already cached, then refresh it from the theme data
  applyModelToUI();

  if (modelProductID) {
    loadPrinterProducts(modelProductID);
  }
}

// --- Init ---
document.addEventListener('DOMContentLoaded', function () {

  // --- Live chat ---
  const chatLinks = document.querySelectorAll('a[href="#live-chat"]');
  chatLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      function openChatWhenReady() {
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
          window.HubSpotConversations.widget.open();
        } else {
          setTimeout(openChatWhenReady, 300);
        }
      }
      openChatWhenReady();
    });
  });

  // --- Support brand toggle ---
  const brands = document.querySelectorAll('.support-box-brand');
  brands.forEach(function (brand) {
    brand.addEventListener('click', function () {
      const list = brand.nextElementSibling;
      const supportBox = brand.closest('.support-box');

      document.querySelectorAll('.support-box-brand').forEach(function (otherBrand) {
        if (otherBrand !== brand) {
          otherBrand.classList.remove('active');
          const otherList = otherBrand.nextElementSibling;
          if (otherList) otherList.style.display = 'none';
          const otherSupportBox = otherBrand.closest('.support-box');
          if (otherSupportBox) otherSupportBox.classList.remove('active');
        }
      });

      const isOpen = list.style.display === 'block';
      if (isOpen) {
        list.style.display = 'none';
        brand.classList.remove('active');
        supportBox.classList.remove('active');
      } else {
        list.style.display = 'block';
        brand.classList.add('active');
        supportBox.classList.add('active');
      }
    });
  });

// --- Handle welcome screen "model" buttons ---
__bnqa('.model').forEach((btn) => {
  btn.addEventListener('click', () => {
    // Hide welcome
    welcomeView.classList.add("hidden");
    welcomeView.classList.remove("visible");

    // Show steps
    stepsView.classList.add("visible");
    stepsView.classList.remove("hidden");
    stepperWrap.classList.add("visible");

    // Start from step 1
    state.currentStep = 1;
    setWithExpiry("bodno:step", "1");

    // ✅ Remove ?step=welcome from URL so refresh doesn't bring it back
    const url = new URL(window.location);
    url.searchParams.delete("step");
    window.history.replaceState({}, "", url);

    renderStepper();
    showStep(1);
  });
});

  // --- Handle generic [data-next] buttons ---
  __bnqa('[data-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      goToStep(Number(btn.dataset.next));
    });
  });

  // --- Init stepper ---
  buildStepper();
  setViewVisibility();
  renderStepper();
  showStep(state.currentStep || 1);
  hydrateUI();


  document.querySelector('[data-step="10"]').addEventListener("click", function () {
    setTimeout(() => {
      // Oct 22 2026: only touch sliders that exist and are initialized (was throwing on every step 9/10 tap)
      jQuery(".blog-boxes.slick-initialized, .sec-no-102-slider.slick-initialized").slick("setPosition");
    }, 800); // wait a little for layout to render
  });

  document.querySelector('[data-step="9"]').addEventListener("click", function () {
    setTimeout(() => {
      jQuery(".pg-step-9.slick-initialized").slick("setPosition");
    }, 800); // wait a little for layout to render
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const storedModel = getWithExpiry("bodno:model");

  if (storedModel) {
    state.currentStep = 2;
    setWithExpiry("bodno:step", "2");

    // 🔑 Refresh the model from the theme data using the stored product id
    const storedProductId = getWithExpiry("bodno:modelProductId");
    if (storedProductId) {
      loadPrinterProducts(storedProductId);
    }
  }

  // ✅ enable clicking steps if they are not locked
  __bnqa(".stepper .step").forEach((el) => {
    el.addEventListener("click", () => {
      if (!el.classList.contains("locked")) {
        const stepNum = Number(el.dataset.step);
        state.currentStep = stepNum;
        setWithExpiry("bodno:step", String(stepNum));
        renderStepper();
        showStep(stepNum);
      }
    });
  });
});